import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * Full-bleed campaign hero: a 16:9 banner image with the headline, copy and
 * VPS branding baked into the picture. The visible heading lives in the image,
 * so the real <h1> is rendered sr-only for SEO / assistive tech.
 */
export function BannerHero({
  image,
  title,
  backHref,
  backLabel,
}: {
  image: string;
  title: string;
  backHref?: string;
  backLabel?: string;
}) {
  return (
    <section>
      <h1 className="sr-only">{title}</h1>
      {backHref && backLabel && (
        <div className="container-tight py-4">
          <Link
            to={backHref}
            className="inline-flex items-center gap-2 text-sm text-muted-foreground transition hover:text-accent"
          >
            <ArrowLeft className="h-4 w-4" />
            {backLabel}
          </Link>
        </div>
      )}
      <img
        src={image}
        alt=""
        aria-hidden="true"
        width={1672}
        height={941}
        className="block h-auto w-full animate-fade-up"
      />
    </section>
  );
}
